/**
 * Set options[SkipErrorReporting] to suppress global unauthorized/logout and request-failed/toast
 * events for noncritical requests. Errors still reach the caller's catch.
 * Uses a namespaced string because RequestInfo.options accepts string keys, not symbols.
 */
export const SkipErrorReporting = 'tioSkipErrorReporting';

/** Set options[SkipErrorToast] to suppress only the request-failed toast; a 401 still logs out. */
export const SkipErrorToast = 'tioSkipErrorToast';
